export default __webpack_public_path__ + "static/media/check-green.aaac7dbe.svg";